export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/issusing-coup' */ './IssusingCoup'
  );
